import { NgModule } from '@angular/core';
import { AbcTileComponent, AbcTileMenuComponent, AbcTileNavMenuComponent } from './abcTileNavMenu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MatIconModule, MatButtonModule, MatMenuModule,MatTooltipModule],
    declarations: [AbcTileNavMenuComponent, AbcTileComponent, AbcTileMenuComponent],
    exports: [AbcTileNavMenuComponent, AbcTileComponent, AbcTileMenuComponent]
})
export class AbcTileNavMenuModule {
  constructor() {}
}
